<form [formGroup]="exportForm">
  <div mat-dialog-title>
    <span>Export dashboard</span>
  </div>

  <div mat-dialog-content>
    <mat-card>
      <mat-card-header class="mb-0">
        <mat-card-title>
          <span>File type</span>
        </mat-card-title>
      </mat-card-header>

      <mat-card-content class="pb-0">
        <mat-radio-group formControlName="format" class="d-flex flex-column">
          @for (
            option of ExportPowerBIReportFileFormatOptions;
            track option.value
          ) {
            <div class="d-flex flex-column mx-n3 ps-1 fileTypeOption">
              <mat-radio-button
                class="d-flex flex-column"
                [value]="option.value"
              >
                <mat-icon class="me-2 icon--large" [svgIcon]="option.icon" />

                <div class="d-flex flex-column py-3 pe-3 w-100 cursor-pointer">
                  <span>
                    <b>{{ option.name }}</b>
                  </span>
                  <span class="text-small text-muted">
                    {{ option.description }}
                  </span>
                </div>
              </mat-radio-button>
            </div>
          }
        </mat-radio-group>
      </mat-card-content>
    </mat-card>
  </div>

  <div mat-dialog-actions class="align-start">
    <button
      mat-flat-button
      color="primary"
      type="submit"
      (click)="onGenerate()"
    >
      <mat-icon svgIcon="download" />
      <div class="spinner"></div>
      Generate
    </button>

    <button mat-button color="primary" type="button" (click)="onClose()">
      Close
    </button>
  </div>
</form>
